module.exports = __webpack_public_path__ + "images/Switch-68cf40.png";